import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

import Check from '@hoa/svg/ServiceRequst/SelfQualif/Check.svg';
import Star from '@hoa/svg/ServiceRequst/SelfQualif/Star.svg';

export const materialsStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:selfQualif.steps.materials.title`,
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.TILES,
      summaryTitle: `quote:selfQualif.steps.materials.summaryTitle`,
      props: {
        name: `providing_materials`,
        options: [
          {
            label: `common:generic.yes`,
            value: `true`,
            icon: <Check />,
          },
          {
            label: `common:generic.no`,
            value: `false`,
            icon: <Star />,
            default: true,
          },
        ],
        validation: [`isRequired`],
      },
    },
  ],
};
